// Utility function to create page URLs
export const createPageUrl = (pageName) => {
  const routes = {
    Home: '/',
    Services: '/services',
    About: '/about',
    Blog: '/blog',
    Contact: '/contact',
    ArticleDetail: '/blog/article',
    AdminContacts: '/admin/contacts',
    AdminArticles: '/admin/articles'
  };
  return routes[pageName] || '/';
};

// Utility to combine classnames (for Tailwind)
export const cn = (...classes) => {
  return classes.filter(Boolean).join(' ');
};
